import dayjs from 'dayjs'

export const getDateWithoutTimezone = (date: dayjs.Dayjs) =>
  dayjs(dayjs(date).set('h', 12).toDate().toISOString().split('T')[0])

export const getDateWithoutTimezoneInStringFormat = (date: dayjs.Dayjs) =>
  dayjs(date).set('h', 12).toISOString().split('T')[0]
